import * as React from "react"
import type { SVGProps } from "react"
const SvgResize = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M19.29 16.86a1 1 0 0 1 1.41 1.42l-3 3a1 1 0 0 1-1.41-1.42zm-.83-4.83a1 1 0 0 1 1.42 1.42l-7 7a1 1 0 0 1-1.42-1.42z" />
  </svg>
)
export default SvgResize
